import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      .", " {\n        max-width: 100vw;\n      }\n\n      .", " {\n        max-width: 100%;\n      }\n    "]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import { css, Global } from '@emotion/core';
import emotionHash from '@emotion/hash';
import React from 'react';
var makeSiclCustomTooltipClassName = function makeSiclCustomTooltipClassName(classNameSuffix) {
  return "sicl-custom-tooltip-".concat(emotionHash(classNameSuffix)).concat(process.env.NODE_ENV === 'development' ? "-".concat(classNameSuffix) : '');
};

// @internal
export var SICLCustomTooltip_GlobalClassNames = {
  Container: makeSiclCustomTooltipClassName('container'),
  Trigger: makeSiclCustomTooltipClassName('trigger')
};

// @internal
export var SICLCustomTooltipGlobalStyles = function SICLCustomTooltipGlobalStyles() {
  return /*#__PURE__*/React.createElement(Global, {
    styles: css(_templateObject(), SICLCustomTooltip_GlobalClassNames.Container, SICLCustomTooltip_GlobalClassNames.Trigger)
  });
};